import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PumpCatalogue.css';

const PumpCatalogue = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedProduct, setExpandedProduct] = useState(null);

  const pumpData = [
    // SUBMERSIBLE PUMPS
    {
      id: 1,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 4\" Submersible Pump - 0.75kW (1HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "0.75kW (1HP)",
      voltage: "230V Single Phase",
      head: "Up to 45 meters",
      flow: "1.5 m³/hr",
      outlet: "1¼\"",
      application: "Domestic boreholes, shallow wells",
      features: ["Stainless steel construction", "Built-in check valve", "Thermal overload protection", "Sand-resistant up to 50g/m³"],
      stock: "Available"
    },
    {
      id: 2,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 4\" Submersible Pump - 1.1kW (1.5HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "1.1kW (1.5HP)",
      voltage: "230V Single Phase",
      head: "Up to 60 meters",
      flow: "2.0 m³/hr",
      outlet: "1¼\"",
      application: "Domestic boreholes, small farms",
      features: ["Stainless steel AISI 304", "Water-filled motor", "Double mechanical seal", "Built-in capacitor"],
      stock: "Available"
    },
    {
      id: 3,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 4\" Submersible Pump - 1.5kW (2HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "1.5kW (2HP)",
      voltage: "230V Single Phase / 400V Three Phase",
      head: "Up to 80 meters",
      flow: "3.0 m³/hr",
      outlet: "1½\"",
      application: "Farm irrigation, community water",
      features: ["Heavy duty bearings", "Sand-resistant impeller", "IP68 protection", "Class F insulation"],
      stock: "Available"
    },
    {
      id: 4,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 4\" Submersible Pump - 2.2kW (3HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "2.2kW (3HP)",
      voltage: "400V Three Phase",
      head: "Up to 100 meters",
      flow: "4.5 m³/hr",
      outlet: "1½\"",
      application: "Large farms, commercial",
      features: ["Cast stainless steel body", "Mixed flow impeller", "High efficiency motor", "Wear-resistant"],
      stock: "Available"
    },
    {
      id: 5,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 4\" Submersible Pump - 3.7kW (5HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "3.7kW (5HP)",
      voltage: "400V Three Phase",
      head: "Up to 130 meters",
      flow: "6.0 m³/hr",
      outlet: "2\"",
      application: "Commercial, community projects",
      features: ["Industrial grade", "High head design", "Continuous duty rating", "Overload protected"],
      stock: "Available"
    },
    {
      id: 6,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 6\" Submersible Pump - 5.5kW (7.5HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "5.5kW (7.5HP)",
      voltage: "400V Three Phase",
      head: "Up to 150 meters",
      flow: "12 m³/hr",
      outlet: "2½\"",
      application: "Large community water schemes",
      features: ["6\" diameter", "High flow rate", "Industrial pump", "Heavy duty construction"],
      stock: "Available"
    },
    {
      id: 7,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 6\" Submersible Pump - 7.5kW (10HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "7.5kW (10HP)",
      voltage: "400V Three Phase",
      head: "Up to 180 meters",
      flow: "18 m³/hr",
      outlet: "3\"",
      application: "Municipal water supply",
      features: ["High capacity", "Multi-stage", "Industrial grade", "Continuous operation"],
      stock: "Available"
    },
    {
      id: 8,
      category: "submersible",
      mainCategory: "Submersible Pumps",
      type: "Versil 6\" Submersible Pump - 11kW (15HP)",
      icon: "🌊",
      image: "/images/products/submersible-pump.jpg",
      power: "11kW (15HP)",
      voltage: "400V Three Phase",
      head: "Up to 220 meters",
      flow: "24 m³/hr",
      outlet: "3\"",
      application: "Large scale water projects",
      features: ["Heavy industrial", "Maximum head", "Premium efficiency", "Extended life"],
      stock: "Available"
    },

    // MONO BLOCK PUMPS
    {
      id: 9,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 0.37kW (0.5HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "0.37kW (0.5HP)",
      voltage: "230V Single Phase",
      head: "Up to 15 meters",
      flow: "1.2 m³/hr",
      outlet: "1\"",
      application: "Small gardens, water transfer",
      features: ["Self-priming", "Compact design", "Copper winding", "Thermal overload"],
      stock: "Available"
    },
    {
      id: 10,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 0.55kW (0.75HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "0.55kW (0.75HP)",
      voltage: "230V Single Phase",
      head: "Up to 20 meters",
      flow: "1.8 m³/hr",
      outlet: "1\"",
      application: "Domestic water supply",
      features: ["Self-priming", "Cast iron body", "Stainless steel shaft", "Quiet operation"],
      stock: "Available"
    },
    {
      id: 11,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 0.75kW (1HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "0.75kW (1HP)",
      voltage: "230V Single Phase",
      head: "Up to 25 meters",
      flow: "2.4 m³/hr",
      outlet: "1¼\"",
      application: "Homes, small irrigation",
      features: ["Self-priming up to 6m", "Class B insulation", "Ball bearings", "Easy maintenance"],
      stock: "Available"
    },
    {
      id: 12,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 1.1kW (1.5HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "1.1kW (1.5HP)",
      voltage: "230V Single Phase",
      head: "Up to 30 meters",
      flow: "3.0 m³/hr",
      outlet: "1¼\"",
      application: "Large homes, small farms",
      features: ["High flow", "Energy efficient", "Durable construction", "Overload protection"],
      stock: "Available"
    },
    {
      id: 13,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 1.5kW (2HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "1.5kW (2HP)",
      voltage: "230V Single Phase / 400V Three Phase",
      head: "Up to 35 meters",
      flow: "4.2 m³/hr",
      outlet: "1½\"",
      application: "Farms, irrigation",
      features: ["Heavy duty", "Continuous rating", "Mechanical seal", "IP44 protection"],
      stock: "Available"
    },
    {
      id: 14,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 2.2kW (3HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "2.2kW (3HP)",
      voltage: "400V Three Phase",
      head: "Up to 42 meters",
      flow: "5.4 m³/hr",
      outlet: "1½\"",
      application: "Commercial, large farms",
      features: ["Three phase", "High efficiency", "Industrial bearings", "Class F insulation"],
      stock: "Available"
    },
    {
      id: 15,
      category: "monoblock",
      mainCategory: "Mono Block Pumps",
      type: "Versil Monoblock Pump - 3.7kW (5HP)",
      icon: "⚙️",
      image: "/images/products/monoblock-pump.jpg",
      power: "3.7kW (5HP)",
      voltage: "400V Three Phase",
      head: "Up to 50 meters",
      flow: "7.8 m³/hr",
      outlet: "2\"",
      application: "Industrial, large scale irrigation",
      features: ["Industrial grade", "High capacity", "Robust construction", "Long life"],
      stock: "Available"
    },

    // CENTRIFUGAL PUMPS
    {
      id: 16,
      category: "centrifugal",
      mainCategory: "Centrifugal Pumps",
      type: "Versil Centrifugal Pump - 1.5kW (2HP)",
      icon: "🔄",
      image: "/images/products/centrifugal-pump.jpg",
      power: "1.5kW (2HP)",
      voltage: "230V/400V",
      head: "Up to 28 meters",
      flow: "8-15 m³/hr",
      inlet: "2\"",
      outlet: "1½\"",
      application: "Water transfer, irrigation",
      features: ["End suction", "Back pull-out design", "Bronze impeller", "Grease lubricated bearings"],
      stock: "Available"
    },
    {
      id: 17,
      category: "centrifugal",
      mainCategory: "Centrifugal Pumps",
      type: "Versil Centrifugal Pump - 2.2kW (3HP)",
      icon: "🔄",
      image: "/images/products/centrifugal-pump.jpg",
      power: "2.2kW (3HP)",
      voltage: "400V Three Phase",
      head: "Up to 35 meters",
      flow: "12-20 m³/hr",
      inlet: "2½\"",
      outlet: "2\"",
      application: "Irrigation schemes, water treatment",
      features: ["High flow", "Industrial duty", "Mechanical seal", "Cast iron casing"],
      stock: "Available"
    },
    {
      id: 18,
      category: "centrifugal",
      mainCategory: "Centrifugal Pumps",
      type: "Versil Centrifugal Pump - 3.7kW (5HP)",
      icon: "🔄",
      image: "/images/products/centrifugal-pump.jpg",
      power: "3.7kW (5HP)",
      voltage: "400V Three Phase",
      head: "Up to 42 meters",
      flow: "18-30 m³/hr",
      inlet: "3\"",
      outlet: "2½\"",
      application: "Large irrigation, industrial",
      features: ["Heavy duty", "High capacity", "Replaceable wear rings", "Shaft sleeve protected"],
      stock: "Available"
    },
    {
      id: 19,
      category: "centrifugal",
      mainCategory: "Centrifugal Pumps",
      type: "Versil Centrifugal Pump - 5.5kW (7.5HP)",
      icon: "🔄",
      image: "/images/products/centrifugal-pump.jpg",
      power: "5.5kW (7.5HP)",
      voltage: "400V Three Phase",
      head: "Up to 50 meters",
      flow: "25-40 m³/hr",
      inlet: "4\"",
      outlet: "3\"",
      application: "Commercial, industrial",
      features: ["Industrial pump", "Continuous duty", "Premium efficiency", "Heavy bearings"],
      stock: "Available"
    },
    {
      id: 20,
      category: "centrifugal",
      mainCategory: "Centrifugal Pumps",
      type: "Versil Centrifugal Pump - 7.5kW (10HP)",
      icon: "🔄",
      image: "/images/products/centrifugal-pump.jpg",
      power: "7.5kW (10HP)",
      voltage: "400V Three Phase",
      head: "Up to 60 meters",
      flow: "35-55 m³/hr",
      inlet: "4\"",
      outlet: "4\"",
      application: "Large industrial, municipal",
      features: ["High head", "High flow", "Industrial standard", "Long service life"],
      stock: "Available"
    },

    // SOLAR PUMPS
    {
      id: 21,
      category: "solar",
      mainCategory: "Solar Pumps",
      type: "Versil Solar Submersible Pump - 0.75kW (1HP) DC",
      icon: "☀️",
      image: "/images/products/solar-pump.jpg",
      power: "0.75kW (1HP)",
      voltage: "DC 96V",
      head: "Up to 40 meters",
      flow: "2.0 m³/hr",
      application: "Solar water systems, remote areas",
      features: ["DC brushless motor", "MPPT compatible", "No batteries needed", "Auto start/stop"],
      stock: "Available"
    },
    {
      id: 22,
      category: "solar",
      mainCategory: "Solar Pumps",
      type: "Versil Solar Submersible Pump - 1.1kW (1.5HP) DC",
      icon: "☀️",
      image: "/images/products/solar-pump.jpg",
      power: "1.1kW (1.5HP)",
      voltage: "DC 120V",
      head: "Up to 60 meters",
      flow: "3.0 m³/hr",
      application: "Solar irrigation, livestock watering",
      features: ["Permanent magnet motor", "Built-in controller", "Dry run protection", "Max power tracking"],
      stock: "Available"
    },
    {
      id: 23,
      category: "solar",
      mainCategory: "Solar Pumps",
      type: "Versil Solar Submersible Pump - 1.5kW (2HP) DC",
      icon: "☀️",
      image: "/images/products/solar-pump.jpg",
      power: "1.5kW (2HP)",
      voltage: "DC 120V",
      head: "Up to 80 meters",
      flow: "4.5 m³/hr",
      application: "Community water, large farms",
      features: ["High efficiency motor", "Soft start", "Low starting current", "Remote monitoring ready"],
      stock: "Available"
    },
    {
      id: 24,
      category: "solar",
      mainCategory: "Solar Pumps",
      type: "Versil Solar Surface Pump - 1.1kW (1.5HP) DC",
      icon: "☀️",
      image: "/images/products/solar-pump.jpg",
      power: "1.1kW (1.5HP)",
      voltage: "DC 120V",
      head: "Up to 25 meters",
      flow: "5-8 m³/hr",
      application: "Solar water transfer from tanks",
      features: ["Self-priming", "DC drive", "Low noise", "Weather resistant"],
      stock: "Available"
    },
    {
      id: 25,
      category: "solar",
      mainCategory: "Solar Pumps",
      type: "Versil Solar Surface Pump - 1.5kW (2HP) DC",
      icon: "☀️",
      image: "/images/products/solar-pump.jpg",
      power: "1.5kW (2HP)",
      voltage: "DC 120V",
      head: "Up to 32 meters",
      flow: "7-12 m³/hr",
      application: "Solar irrigation systems",
      features: ["High flow", "Efficient DC motor", "IP54 protection", "Easy installation"],
      stock: "Available"
    },

    // OPEN WELL PUMPS
    {
      id: 26,
      category: "openwell",
      mainCategory: "Open Well Pumps",
      type: "Versil Open Well Pump - 1.1kW (1.5HP)",
      icon: "⛲",
      image: "/images/products/openwell-pump.jpg",
      power: "1.1kW (1.5HP)",
      voltage: "230V Single Phase",
      head: "Up to 18 meters",
      flow: "6-10 m³/hr",
      outlet: "2\"",
      application: "Wells, reservoirs, tanks",
      features: ["Open well design", "Foot valve included", "Strainer included", "Easy installation"],
      stock: "Available"
    },
    {
      id: 27,
      category: "openwell",
      mainCategory: "Open Well Pumps",
      type: "Versil Open Well Pump - 1.5kW (2HP)",
      icon: "⛲",
      image: "/images/products/openwell-pump.jpg",
      power: "1.5kW (2HP)",
      voltage: "230V Single Phase",
      head: "Up to 22 meters",
      flow: "8-14 m³/hr",
      outlet: "2\"",
      application: "Large wells, water storage",
      features: ["Cast iron construction", "Bronze impeller", "Mechanical seal", "Overload protected"],
      stock: "Available"
    },
    {
      id: 28,
      category: "openwell",
      mainCategory: "Open Well Pumps",
      type: "Versil Open Well Pump - 2.2kW (3HP)",
      icon: "⛲",
      image: "/images/products/openwell-pump.jpg",
      power: "2.2kW (3HP)",
      voltage: "400V Three Phase",
      head: "Up to 28 meters",
      flow: "12-20 m³/hr",
      outlet: "2½\"",
      application: "Commercial, large reservoirs",
      features: ["Heavy duty", "High capacity", "Industrial motor", "Continuous duty"],
      stock: "Available"
    },

    // PUMP MOTORS
    {
      id: 29,
      category: "motors",
      mainCategory: "Submersible Pump Motors",
      type: "Versil 4\" SS Motor - 0.75kW (1HP)",
      icon: "⚡",
      image: "/images/products/pump-motor.jpg",
      power: "0.75kW (1HP)",
      voltage: "230V Single Phase",
      current: "5.2A",
      speed: "2850 RPM",
      application: "4\" submersible pumps",
      features: ["Stainless steel AISI 304", "Water-filled", "Built-in capacitor", "Thermal protection"],
      stock: "Available"
    },
    {
      id: 30,
      category: "motors",
      mainCategory: "Submersible Pump Motors",
      type: "Versil 4\" SS Motor - 1.1kW (1.5HP)",
      icon: "⚡",
      image: "/images/products/pump-motor.jpg",
      power: "1.1kW (1.5HP)",
      voltage: "230V Single Phase",
      current: "7.2A",
      speed: "2850 RPM",
      application: "4\" submersible pumps",
      features: ["Stainless steel", "Water-filled", "Double bearing", "IP68"],
      stock: "Available"
    },
    {
      id: 31,
      category: "motors",
      mainCategory: "Submersible Pump Motors",
      type: "Versil 4\" SS Motor - 1.5kW (2HP)",
      icon: "⚡",
      image: "/images/products/pump-motor.jpg",
      power: "1.5kW (2HP)",
      voltage: "230V Single Phase",
      current: "9.5A",
      speed: "2850 RPM",
      application: "4\" submersible pumps",
      features: ["Stainless steel 304", "Water-filled", "Class F insulation", "Ball bearings"],
      stock: "Available"
    },
    {
      id: 32,
      category: "motors",
      mainCategory: "Submersible Pump Motors",
      type: "Versil 4\" SS Motor - 2.2kW (3HP)",
      icon: "⚡",
      image: "/images/products/pump-motor.jpg",
      power: "2.2kW (3HP)",
      voltage: "400V Three Phase",
      current: "4.8A",
      speed: "2850 RPM",
      application: "4\" submersible pumps",
      features: ["Stainless steel", "Water-filled", "Industrial grade", "Long life"],
      stock: "Available"
    },
    {
      id: 33,
      category: "motors",
      mainCategory: "Submersible Pump Motors",
      type: "Versil 6\" SS Motor - 5.5kW (7.5HP)",
      icon: "⚡",
      image: "/images/products/pump-motor.jpg",
      power: "5.5kW (7.5HP)",
      voltage: "400V Three Phase",
      current: "11.5A",
      speed: "2850 RPM",
      application: "6\" submersible pumps",
      features: ["6\" diameter", "Heavy duty", "Oil-filled option", "Premium bearings"],
      stock: "Available"
    },
    {
      id: 34,
      category: "motors",
      mainCategory: "Submersible Pump Motors",
      type: "Versil 6\" SS Motor - 7.5kW (10HP)",
      icon: "⚡",
      image: "/images/products/pump-motor.jpg",
      power: "7.5kW (10HP)",
      voltage: "400V Three Phase",
      current: "15.2A",
      speed: "2850 RPM",
      application: "6\" submersible pumps",
      features: ["Industrial motor", "High efficiency", "Thrust bearing", "Class H insulation"],
      stock: "Available"
    },

    // CONTROL PANELS
    {
      id: 35,
      category: "controllers",
      mainCategory: "Pump Control Panels",
      type: "Single Phase Control Panel - 1.5kW",
      icon: "📟",
      image: "/images/products/control-panel.jpg",
      power: "Up to 1.5kW",
      voltage: "230V",
      features: ["Manual/Auto mode", "Dry run protection", "Overload relay", "Phase failure protection", "Float switch input", "Level sensor input"],
      stock: "Available"
    },
    {
      id: 36,
      category: "controllers",
      mainCategory: "Pump Control Panels",
      type: "Three Phase Control Panel - 3.7kW",
      icon: "📟",
      image: "/images/products/control-panel.jpg",
      power: "Up to 3.7kW",
      voltage: "400V",
      features: ["DOL starter", "Dry run protection", "Overload protection", "Phase failure relay", "Auto restart", "Digital display"],
      stock: "Available"
    },
    {
      id: 37,
      category: "controllers",
      mainCategory: "Pump Control Panels",
      type: "Three Phase Control Panel - 7.5kW",
      icon: "📟",
      image: "/images/products/control-panel.jpg",
      power: "Up to 7.5kW",
      voltage: "400V",
      features: ["Star-Delta starter", "Digital controller", "Dry run protection", "Overload", "Phase failure", "Auto/Manual", "Remote monitoring"],
      stock: "Available"
    },
    {
      id: 38,
      category: "controllers",
      mainCategory: "Pump Control Panels",
      type: "Three Phase Control Panel - 11kW",
      icon: "📟",
      image: "/images/products/control-panel.jpg",
      power: "Up to 11kW",
      voltage: "400V",
      features: ["Star-Delta", "PLC ready", "Touch screen option", "All protections", "Data logging", "Remote access"],
      stock: "Available"
    },
    {
      id: 39,
      category: "controllers",
      mainCategory: "Pump Control Panels",
      type: "Solar Pump Controller - 1.5kW DC",
      icon: "📟",
      image: "/images/products/control-panel.jpg",
      power: "Up to 1.5kW DC",
      voltage: "96-120V DC",
      features: ["MPPT tracking", "Dry run protection", "Soft start", "LCD display", "Low voltage protection", "Auto restart"],
      stock: "Available"
    },

    // COLUMN PIPES
    {
      id: 40,
      category: "accessories",
      mainCategory: "Column Pipes",
      type: "UPVC Column Pipe 1¼\" - 3m length",
      icon: "🧴",
      image: "/images/products/column-pipe.jpg",
      sizes: ["1¼\" diameter"],
      length: "3 meters",
      material: "UPVC",
      application: "Rising main for submersible pumps",
      features: ["Lightweight", "Corrosion resistant", "Threaded ends", "Pressure rated"],
      stock: "Available"
    },
    {
      id: 41,
      category: "accessories",
      mainCategory: "Column Pipes",
      type: "UPVC Column Pipe 1½\" - 3m length",
      icon: "🧴",
      image: "/images/products/column-pipe.jpg",
      sizes: ["1½\" diameter"],
      length: "3 meters",
      material: "UPVC",
      application: "Rising main for submersible pumps",
      features: ["Lightweight", "Corrosion resistant", "Threaded ends", "Pressure rated"],
      stock: "Available"
    },
    {
      id: 42,
      category: "accessories",
      mainCategory: "Column Pipes",
      type: "UPVC Column Pipe 2\" - 3m length",
      icon: "🧴",
      image: "/images/products/column-pipe.jpg",
      sizes: ["2\" diameter"],
      length: "3 meters",
      material: "UPVC",
      application: "Rising main for larger pumps",
      features: ["Heavy duty", "Corrosion resistant", "Threaded", "High pressure"],
      stock: "Available"
    },
    {
      id: 43,
      category: "accessories",
      mainCategory: "Column Pipes",
      type: "UPVC Column Pipe 2½\" - 3m length",
      icon: "🧴",
      image: "/images/products/column-pipe.jpg",
      sizes: ["2½\" diameter"],
      length: "3 meters",
      material: "UPVC",
      application: "Industrial pump rising main",
      features: ["Extra heavy duty", "Threaded connections", "Pressure tested"],
      stock: "Available"
    },
    {
      id: 44,
      category: "accessories",
      mainCategory: "Column Pipes",
      type: "UPVC Column Pipe 3\" - 3m length",
      icon: "🧴",
      image: "/images/products/column-pipe.jpg",
      sizes: ["3\" diameter"],
      length: "3 meters",
      material: "UPVC",
      application: "Large pump installations",
      features: ["Maximum size", "Reinforced", "Industrial grade"],
      stock: "Available"
    },
    {
      id: 45,
      category: "accessories",
      mainCategory: "Column Pipe Accessories",
      type: "Column Pipe Couplings",
      icon: "🔗",
      image: "/images/products/column-pipe.jpg",
      sizes: ["1¼\"", "1½\"", "2\"", "2½\"", "3\""],
      material: "Stainless Steel / UPVC",
      application: "Connecting column pipes",
      stock: "Available"
    },
    {
      id: 46,
      category: "accessories",
      mainCategory: "Column Pipe Accessories",
      type: "Column Pipe Clamps",
      icon: "🔧",
      image: "/images/products/column-pipe.jpg",
      sizes: ["1¼\"", "1½\"", "2\"", "2½\"", "3\""],
      material: "Galvanized Steel",
      application: "Supporting column pipes",
      stock: "Available"
    },

    // PUMP ACCESSORIES
    {
      id: 47,
      category: "accessories",
      mainCategory: "Pump Accessories",
      type: "Non-Return Valve (Check Valve)",
      icon: "↩️",
      image: "/images/products/column-pipe.jpg",
      sizes: ["1¼\"", "1½\"", "2\"", "2½\"", "3\"", "4\""],
      material: "Stainless Steel / Brass",
      application: "Preventing backflow",
      stock: "Available"
    },
    {
      id: 48,
      category: "accessories",
      mainCategory: "Pump Accessories",
      type: "Foot Valve with Strainer",
      icon: "🦶",
      image: "/images/products/column-pipe.jpg",
      sizes: ["1¼\"", "1½\"", "2\"", "2½\"", "3\"", "4\""],
      material: "Cast Iron / Stainless Steel",
      application: "Suction line priming",
      stock: "Available"
    },
    {
      id: 49,
      category: "accessories",
      mainCategory: "Pump Accessories",
      type: "Pressure Switch",
      icon: "⚙️",
      image: "/images/products/control-panel.jpg",
      pressure: "Adjustable 1-5 bar",
      application: "Automatic pump control",
      features: ["Adjustable differential", "IP54", "20A rating"],
      stock: "Available"
    },
    {
      id: 50,
      category: "accessories",
      mainCategory: "Pump Accessories",
      type: "Pressure Tank (Hydrophore)",
      icon: "🛢️",
      image: "/images/products/column-pipe.jpg",
      sizes: ["24L", "50L", "100L", "200L", "500L"],
      material: "Steel with bladder",
      application: "Constant pressure systems",
      stock: "Available"
    },
    {
      id: 51,
      category: "accessories",
      mainCategory: "Pump Accessories",
      type: "Cable Connector (Pump)",
      icon: "🔌",
      image: "/images/products/control-panel.jpg",
      sizes: ["For 1.5mm²", "For 2.5mm²", "For 4mm²", "For 6mm²", "For 10mm²"],
      application: "Waterproof cable connection",
      stock: "Available"
    }
  ];

  // Get unique categories with counts and images
  const categoryCounts = pumpData.reduce((acc, product) => {
    acc[product.category] = (acc[product.category] || 0) + 1;
    return acc;
  }, {});

  const categories = [
    { 
      id: 'submersible', 
      label: 'Submersible Pumps', 
      icon: '🌊', 
      image: '/images/products/submersible-pump.jpg',
      description: 'Stainless steel pumps for boreholes and deep wells',
      count: categoryCounts['submersible'] || 0 
    },
    { 
      id: 'monoblock', 
      label: 'Mono Block Pumps', 
      icon: '⚙️', 
      image: '/images/products/monoblock-pump.jpg',
      description: 'Self-priming surface pumps for domestic use',
      count: categoryCounts['monoblock'] || 0 
    },
    { 
      id: 'centrifugal', 
      label: 'Centrifugal Pumps', 
      icon: '🔄', 
      image: '/images/products/centrifugal-pump.jpg',
      description: 'High flow pumps for irrigation and industrial use',
      count: categoryCounts['centrifugal'] || 0 
    },
    { 
      id: 'solar', 
      label: 'Solar Pumps', 
      icon: '☀️', 
      image: '/images/products/solar-pump.jpg',
      description: 'DC solar-powered pumps for remote areas',
      count: categoryCounts['solar'] || 0 
    },
    { 
      id: 'openwell', 
      label: 'Open Well Pumps', 
      icon: '⛲', 
      image: '/images/products/openwell-pump.jpg',
      description: 'Pumps for wells, reservoirs and tanks',
      count: categoryCounts['openwell'] || 0 
    },
    { 
      id: 'motors', 
      label: 'Pump Motors', 
      icon: '⚡', 
      image: '/images/products/pump-motor.jpg',
      description: 'Stainless steel submersible motors',
      count: categoryCounts['motors'] || 0 
    },
    { 
      id: 'controllers', 
      label: 'Control Panels', 
      icon: '📟', 
      image: '/images/products/control-panel.jpg',
      description: 'Intelligent pump controllers with protection',
      count: categoryCounts['controllers'] || 0 
    },
    { 
      id: 'accessories', 
      label: 'Accessories', 
      icon: '🔧', 
      image: '/images/products/column-pipe.jpg',
      description: 'Column pipes, valves, and fittings',
      count: categoryCounts['accessories'] || 0 
    }
  ];

  const handleCategoryClick = (categoryId) => {
    if (selectedCategory === categoryId) {
      setSelectedCategory(null); // Back to categories view
    } else {
      setSelectedCategory(categoryId);
      setExpandedProduct(null); // Reset expanded product when changing category
      setSearchTerm(''); // Clear search when changing category
    }
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
    setExpandedProduct(null);
    setSearchTerm('');
  };

  const toggleExpand = (id) => {
    if (expandedProduct === id) {
      setExpandedProduct(null);
    } else {
      setExpandedProduct(id);
    }
  };

  // Filter products based on selected category and search
  const filteredProducts = selectedCategory
    ? pumpData.filter(product => 
        product.category === selectedCategory &&
        (searchTerm === '' || 
         product.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
         product.power?.toLowerCase().includes(searchTerm.toLowerCase()) ||
         product.application?.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    : [];

  // If a category is selected, show products in that category
  if (selectedCategory) {
    const category = categories.find(c => c.id === selectedCategory);
    
    return (
      <div className="catalogue-page pump-catalogue category-view">
        <div className="container">
          {/* Back Button */}
          <button className="back-button" onClick={handleBackToCategories}>
            ← Back to All Categories
          </button>

          {/* Category Header with Image */}
          <div className="category-header pump-category-header">
            <div className="category-header-image">
              <img src={category.image} alt={category.label} />
            </div>
            <div className="category-header-info">
              <div className="category-header-icon">{category.icon}</div>
              <div>
                <h1 className="category-title">{category.label}</h1>
                <p className="category-description">{category.description}</p>
              </div>
            </div>
          </div>

          {/* Search within category */}
          <div className="catalogue-search">
            <input
              type="text"
              placeholder={`Search in ${category.label}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>

          <div className="results-count">
            Showing {filteredProducts.length} products in {category.label}
          </div>

          {/* Products Grid */}
          <div className="catalogue-enhanced-grid">
            {filteredProducts.map((product) => (
              <div key={product.id} className={`catalogue-enhanced-card pump-card ${expandedProduct === product.id ? 'expanded' : ''}`}>
                <div className="card-header" style={{ backgroundColor: '#0066CC' }}>
                  {product.image && (
                    <div className="card-header-image">
                      <img src={product.image} alt={product.type} />
                    </div>
                  )}
                  <span className="card-icon">{product.icon}</span>
                  <h3>{product.type}</h3>
                  <button className="expand-btn" onClick={() => toggleExpand(product.id)}>
                    {expandedProduct === product.id ? '−' : '+'}
                  </button>
                </div>
                
                <div className="card-content">
                  <div className="card-main-category">{product.mainCategory}</div>
                  
                  <div className="card-specs">
                    {product.power && (
                      <div className="spec-item">
                        <span className="spec-label">Power:</span>
                        <span className="spec-value highlight">{product.power}</span>
                      </div>
                    )}
                    
                    {product.voltage && (
                      <div className="spec-item">
                        <span className="spec-label">Voltage:</span>
                        <span className="spec-value">{product.voltage}</span>
                      </div>
                    )}
                    
                    {product.head && (
                      <div className="spec-item">
                        <span className="spec-label">Max Head:</span>
                        <span className="spec-value">{product.head}</span>
                      </div>
                    )}
                    
                    {product.flow && (
                      <div className="spec-item">
                        <span className="spec-label">Flow Rate:</span>
                        <span className="spec-value">{product.flow}</span>
                      </div>
                    )}
                    
                    {product.sizes && (
                      <div className="spec-item">
                        <span className="spec-label">Sizes:</span>
                        <div className="size-chips">
                          {Array.isArray(product.sizes) ? 
                            product.sizes.slice(0, 3).map((size, i) => (
                              <span key={i} className="size-chip">{size}</span>
                            )) : 
                            <span className="size-chip">{product.sizes}</span>
                          }
                          {product.sizes && product.sizes.length > 3 && (
                            <span className="size-chip more">+{product.sizes.length - 3}</span>
                          )}
                        </div>
                      </div>
                    )}
                    
                    {product.outlet && (
                      <div className="spec-item">
                        <span className="spec-label">Outlet:</span>
                        <span className="spec-value">{product.outlet}</span>
                      </div>
                    )}
                    
                    {product.stock && (
                      <div className="spec-item stock">
                        <span className="spec-label">Stock:</span>
                        <span className="spec-value available">{product.stock}</span>
                      </div>
                    )}
                  </div>

                  {expandedProduct === product.id && (
                    <div className="product-extended">
                      <h4>Features & Applications</h4>
                      {product.features && (
                        <ul className="feature-list">
                          {product.features.map((feature, i) => (
                            <li key={i}>✓ {feature}</li>
                          ))}
                        </ul>
                      )}
                      {product.application && (
                        <p className="application-text">
                          <strong>Application:</strong> {product.application}
                        </p>
                      )}
                      <div className="extended-actions">
                        <Link to={`/contact?product=${encodeURIComponent(product.type)}`} className="btn-quote">Request Quote</Link>
                      </div>
                    </div>
                  )}
                  
                  {expandedProduct !== product.id && (
                    <div className="card-actions">
                      <Link to={`/contact?product=${encodeURIComponent(product.type)}`} className="btn-quote">Get Quote</Link>
                      <button className="btn-view" onClick={() => toggleExpand(product.id)}>Details</button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-results">
              <p>No products found matching "{searchTerm}"</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Otherwise show all categories (dashboard view)
  return (
    <div className="catalogue-page pump-catalogue">
      <div className="container">
        <h1 className="catalogue-title">Versil Pumps Catalogue</h1>
        <p className="catalogue-subtitle">Complete Range of Quality Pumps from Masai Store Ltd</p>

        <div className="catalogue-search">
          <input
            type="text"
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>

        {/* Categories Dashboard with Images */}
        <div className="categories-dashboard pumps-dashboard">
          {categories
            .filter(cat => 
              cat.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
              cat.description.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((category) => (
              <div
                key={category.id}
                className="category-dashboard-card pump-category-card"
                onClick={() => handleCategoryClick(category.id)}
              >
                <div className="category-dashboard-image">
                  <img src={category.image} alt={category.label} />
                  <div className="category-image-overlay">
                    <span className="category-icon-large">{category.icon}</span>
                  </div>
                </div>
                <h3>{category.label}</h3>
                <p className="category-description-small">{category.description}</p>
                <div className="category-footer">
                  <span className="product-count">{category.count} products</span>
                  <span className="view-link">View →</span>
                </div>
              </div>
            ))}
        </div>

        {categories.filter(cat => 
          cat.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
          cat.description.toLowerCase().includes(searchTerm.toLowerCase())
        ).length === 0 && (
          <div className="no-results">
            <p>No categories found matching "{searchTerm}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PumpCatalogue;